module.exports = {
	title: 'Todd Vanderlin',
	description: 'Interactive installations, augmented reality, ARVR, ARkit, openframeworks, generative art, creative coding, motion graphics, design, ideo',
	url: 'http://www.vanderlin.cc/',
	keywords: 'Interactive installations, augmented reality, ARVR, ARkit, openframeworks, generative art, creative coding, motion graphics, design, ideo',
	image: 'https://www.vanderlin.cc/static/vanderlin.png'
}